import { IPayLater } from 'api/payLater';
import * as React from 'react';
import { humanFriendlyDate } from './helpers';

interface IPayLaterResponseProps {
	response: IPayLater;
}

enum PayLaterResponses {
	ALREADY_REGISTERED = 'ALREADY_REGISTERED',
	NOT_FOUND = 'BOOKING_NOT_FOUND',
	TOO_LATE = 'TOO_LATE',
	OUTSIDE_CANCELLATION_PERIOD = 'OUTSIDE_FREE_CANCELLATION_PERIOD',
	SUCCESS = 'REGISTRATION_SUCCESSFUL',
}

const errorResponseTemplate = (customMessage: string) => (<div>
	<p>
		We've received your request to delay payment for this
		booking.
	</p>
	<p>{customMessage}</p>
</div>);

export const PayLaterResponseDisplay: React.FC<IPayLaterResponseProps> = (props) => {
	const { response } = props;

	const paymentDate = response.paymentDate ? humanFriendlyDate(response.paymentDate) : undefined;

	if (response.outcome === PayLaterResponses.SUCCESS) {
		return (
			<div>
				<p>
					Your request to delay payment for your booking has been
					successful.
				</p>
				{paymentDate && <p>
					{`Payment will now be taken on or around ${paymentDate}`}
				</p>}
				<p>
					Thanks for booking a property managed by Travelnest. We
					hope you enjoy your trip!
				</p>
			</div>);
	}
	// Handle various failure scenarios
	switch (response.outcome) {
		case PayLaterResponses.ALREADY_REGISTERED: {
			const paymentTaken = paymentDate ? ` Payment will be taken on or around ${paymentDate}.` : '';
			return errorResponseTemplate(`A successful payment delay has already been made for this booking.${paymentTaken}`);
		}
		case PayLaterResponses.OUTSIDE_CANCELLATION_PERIOD:
		case PayLaterResponses.TOO_LATE: {
			return errorResponseTemplate('It is too late to delay payment for this booking. \
				Payment has already been taken, or will be soon.');
		}
		case PayLaterResponses.NOT_FOUND:
		default: {
			return errorResponseTemplate('This booking cannot be found.');
		}
	}
};
